import { computed, unref } from 'vue';
import { getAppStore } from '@/store';

export function useMenuSetting() {
  const appStore = getAppStore();

  const getCollapsed = computed(() => appStore.getMenuSetting.collapsed);

  const getShowMenu = computed(() => appStore.getMenuSetting.show);

  const getCalcContentWidth = computed(() => {
    const collapsed = unref(getCollapsed);
    const width = collapsed ? 0 : appStore.getMenuSetting.menuWidth;
    return `calc(100% - ${width}px)`;
  });

  return {
    toggleCollapsed: (collapsed = !unref(getCollapsed)) => {
      appStore.setMenuSetting({ collapsed });
    },
    getShowMenu,
    getCollapsed,
    getCalcContentWidth,
  };
}
